import { Accordion } from './Accordion';
import register from './register';

register(Accordion);
